// extracted by mini-css-extract-plugin
export default {"editButton":"EditReportButton_editButton__f1-L8"};